<script setup>
import { ref } from 'vue'
import { useForm } from '@inertiajs/vue3'
import { useI18n } from 'vue-i18n'
import DriverAuthLayout from '@/Layouts/DriverAuthLayout.vue'

defineOptions({ layout: DriverAuthLayout })

const { t } = useI18n()
const code = ref('')
const form = useForm({ code: '' })

function submit() {
  form.code = code.value
  form.post('/otp/verify', { preserveScroll: true })
}
</script>

<template>
  <h1 class="verify-title">{{ t('driver_portal.otp.verify.title') }}</h1>
  <p class="verify-sub">{{ t('driver_portal.otp.verify.sub') }}</p>
  <form @submit.prevent="submit" class="verify-form">
    <input
      v-model="code"
      type="text"
      inputmode="numeric"
      pattern="\d{6}"
      maxlength="6"
      autocomplete="one-time-code"
      required
      class="verify-input"
      placeholder="000000"
    />
    <button type="submit" :disabled="form.processing || code.length !== 6" class="verify-submit">
      {{ form.processing ? t('driver_portal.otp.verify.verifying') : t('driver_portal.otp.verify.cta') }}
    </button>
    <a href="/otp" class="verify-link">{{ t('driver_portal.otp.verify.resend') }}</a>
  </form>
</template>

<style scoped>
.verify-title { font-size: 1.25rem; font-weight: 700; color: var(--ink); margin: 0 0 0.5rem; }
.verify-sub   { color: var(--inkSoft); margin: 0 0 1rem; font-size: 0.9375rem; }
.verify-form  { display: grid; gap: 0.875rem; }
.verify-input {
  width: 100%; padding: 0.65rem; font-size: 1.5rem;
  font-family: var(--font-mono, monospace);
  text-align: center; letter-spacing: 0.4em; background: var(--surface);
  border: 1px solid var(--line); border-radius: var(--radius-input, 8px); color: var(--ink);
}
.verify-input:focus { outline: 2px solid var(--accent); outline-offset: 1px; }
.verify-submit {
  padding: 0.65rem 1rem; border: 0; border-radius: var(--radius-button, 8px);
  background: var(--accent); color: var(--accentInk); font-weight: 600; cursor: pointer;
}
.verify-submit:disabled { opacity: 0.6; cursor: not-allowed; }
.verify-link { color: var(--accent); text-decoration: none; font-size: 0.875rem; text-align: center; }
</style>
